import { create } from 'zustand';

export type UserRole =
  | 'organizer'
  | 'verified_organizer'
  | 'builder'
  | 'athlete'
  | 'support';

export interface AuthUser {
  uid: string;
  email: string;
  displayName: string | null;
  roles: UserRole[];
}

interface AuthState {
  user: AuthUser | null;
  loading: boolean;
  setUser: (user: AuthUser | null) => void;
  setLoading: (loading: boolean) => void;
  hasRole: (role: UserRole) => boolean;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  loading: true,
  setUser: (user) => set({ user, loading: false }),
  setLoading: (loading) => set({ loading }),
  hasRole: (role) => get().user?.roles.includes(role) ?? false,
}));
